import React, { useEffect, useState, useMemo } from "react";
import PageHero from "../components/PageHero";
import { api } from "../lib/api";
import { X } from "lucide-react";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("Semua");
  const [preview, setPreview] = useState(null);
  useEffect(() => { api.get("/gallery?limit=200").then(({ data }) => setItems(data.items)).catch(() => {}); }, []);
  const categories = useMemo(() => ["Semua", ...Array.from(new Set(items.map((i) => i.category)))], [items]);
  const filtered = cat === "Semua" ? items : items.filter((i) => i.category === cat);
  return (
    <div data-testid="gallery-page">
      <PageHero eyebrow="Galeri" title="Momen & Kenangan" subtitle="Potret kegiatan, pembelajaran, kompetisi, seni, dan kehidupan sekolah di SMAS YPK 2 Biak." image="https://images.pexels.com/photos/35550999/pexels-photo-35550999.jpeg?auto=compress&cs=tinysrgb&w=2000" />
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((c) => (
              <button key={c} data-testid={`gallery-filter-${c.toLowerCase()}`} onClick={() => setCat(c)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${cat === c ? "bg-[#0B1D3A] text-white" : "bg-slate-100 text-slate-700 hover:bg-slate-200"}`}>{c}</button>
            ))}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {filtered.map((g) => (
              <button key={g.id} data-testid={`gallery-item-${g.id}`} onClick={() => setPreview(g)} className="group relative aspect-square overflow-hidden rounded-xl cursor-zoom-in">
                <img src={g.image_url} alt={g.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1D3A]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                  <div>
                    <div className="text-white font-serif font-bold text-sm">{g.title}</div>
                    <div className="text-amber-300 text-xs font-semibold uppercase tracking-wider mt-0.5">{g.category}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>
      {preview && (
        <div data-testid="gallery-lightbox" className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-sm flex items-center justify-center p-6" onClick={() => setPreview(null)}>
          <button data-testid="lightbox-close" onClick={() => setPreview(null)} className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"><X /></button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={preview.image_url} alt={preview.title} className="w-full max-h-[80vh] object-contain rounded-lg" />
            <div className="mt-4 text-white text-center">
              <div className="font-serif text-xl font-bold">{preview.title}</div>
              <div className="text-amber-400 text-xs uppercase tracking-widest mt-1">{preview.category}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
